export default __webpack_public_path__ + "69d3a6e76cefaf30aa3a383aeaf62b1f.woff";